if (!customElements.get("tabs-configurator")) {
  class TabsConfigurator extends HTMLElement {
    constructor() {
      super();
      this.navigation = this.querySelector(".tabs-configurator__navigation");
      this.bars = this.querySelectorAll(".tabs-configurator__bar");
      this.tabs = this.querySelectorAll(".tabs-configurator__tab");
      this.tilesList = this.querySelectorAll(".tabs-configurator__tiles");
      this.tiles = this.querySelectorAll(".tabs-configurator__tile");
      this.inputs = this.querySelectorAll(".tabs-configurator__input");
      this.actButton = this.querySelector(".tabs-configurator__button");
      this.progressBar = this.querySelector(".tabs-configurator__progress-wrapper");

      this.cards = this.querySelectorAll(".tabs-configurator__card");
      this.cardButtons = this.querySelectorAll(".bundle-add-btn");
      this.quantityButtons = this.querySelectorAll(".bundle-set-quantity-btn");
      this.picker = this.querySelector(".tabs-configurator__picker");
      this.options = this.querySelectorAll(".tabs-configurator__option");
      this.discounts = this.querySelectorAll(".tabs-configurator__discount");
      this.removeOptions = this.querySelectorAll(
        ".tabs-configurator__option-remove",
      );

      this.salePrice = this.querySelector(".tabs-configurator__sale-price");
      this.originalPrice = this.querySelector(
        ".tabs-configurator__original-price",
      );

      this.optionIndex = 0;
      this.productQuantity = 0;
      this.barIndex = 0;
      this.cloneOption = this.options[0].cloneNode(true);

      this.discountFistText = this.discounts[0].innerHTML;
      this.discountSecondText = this.discounts[1].innerHTML;

      this.discounts[0].innerHTML = this.discountFistText.replace("%p", 2);

      this.initializeTabs();
      this.initializeFilters();
      this.initializePicker();

      this.addProductsToCartDrawer();
      this.updateActionButtonState();
    }

    //  ============ PICKER SETTINGS ============

    initializePicker() {
      // Initialize listeners for setting and removing options
      this.setupOptionListeners();
      // this.setupRemoveListeners();
    }

    setupOptionListeners() {
      // Add event listeners to each card button for selecting options
      this.cardButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          this.updateQuantity(
            btn,
            this.getCurrentQuantity(btn),
            this.getCurrentQuantity(btn) + 1,
          );
          this.handleOptionSelect(btn, e);
          this.resortOptions();
        });
      });

      this.quantityButtons.forEach((btn) => {
        btn.querySelector("[data-minus]").addEventListener("click", (e) => {
          const index = parseInt(
            Array.from(this.options)
              .reverse()
              .find((option) => option.dataset.id === btn.dataset.id).dataset
              .index,
          );
          this.handleOptionRemove(index);
          this.resortOptions();
        });
        btn.querySelector("[data-plus]").addEventListener("click", (e) => {
          const oldQuantity = this.getCurrentQuantity(btn);
          const newQuantity = oldQuantity + 1;

          this.updateQuantity(btn, oldQuantity, newQuantity);
          this.handleOptionSelect(btn, e);

          this.resortOptions();
        });
      });
    }

    updateQuantity(btn, oldQuantity, newQuantity) {
      const qtyButton = this.querySelector(
        `.bundle-set-quantity-btn[data-id='${btn.dataset.id}']`,
      );
      const addButton = this.querySelector(
        `.bundle-add-btn[data-id='${btn.dataset.id}']`,
      );

      qtyButton.setAttribute("data-quantity", newQuantity);
      addButton.setAttribute("data-quantity", newQuantity);

      qtyButton.querySelector("span").textContent = newQuantity;
      console.log(qtyButton, addButton);
    }

    getCurrentQuantity(btn) {
      return parseInt(btn.dataset.quantity);
    }

    setupRemoveListeners() {
      // Add event listeners to each remove button for removing options
      this.removeOptions.forEach((remove, index) => {
        remove.addEventListener("click", () => {
          this.handleOptionRemove(index);
          this.resortOptions();
        });
      });
    }

    updateProgressBar(progress) {
      this.progressBar.dataset.progress = progress > 4 ? 4 : progress;
    }

    handleOptionSelect(btn, e) {
      // Handles option selection, increments quantity, updates UI and prices
      e.preventDefault();
      e.stopPropagation();

      const quantity = this.getCurrentQuantity(btn);

      const qtyButton = this.querySelector(
        `.bundle-set-quantity-btn[data-id='${btn.dataset.id}']`,
      );
      const addButton = this.querySelector(
        `.bundle-add-btn[data-id='${btn.dataset.id}']`,
      );


      if (quantity >= 1) {
        addButton.setAttribute("data-show", false);
        qtyButton.setAttribute("data-show", true);
      } else if (quantity == 0) {
        addButton.setAttribute("data-show", true);
        qtyButton.setAttribute("data-show", false);
        this.updateProgressBar(0)
        return;
      }

      this.productQuantity++;
      this.updateProgressBar(this.productQuantity);
      const img = this.createImageElement(btn.dataset.src); // Create and append product image
      this.pickOption(img, btn); // Mark option as picked and append image
      this.updateActionButtonState(); // Adjust ACT button based on quantity
      this.checkNextAvailableOption(); // Move to next available option
      btn.setAttribute("data-picked", ""); // Mark button as picked
      this.updatePrices(); // Update the displayed prices
      this.updateDiscountMessage();
    }

    handleOptionRemove(index) {
      const variantId = this.options[index].dataset.id;

      const qtyButton = this.querySelector(
        `.bundle-set-quantity-btn[data-id='${variantId}']`,
      );
      const addButton = this.querySelector(
        `.bundle-add-btn[data-id='${variantId}']`,
      );

      const currentQuantity = this.getCurrentQuantity(qtyButton) - 1;
      this.updateQuantity(qtyButton, currentQuantity + 1, currentQuantity);

      if (currentQuantity == 0) {
        addButton.setAttribute("data-show", true);
        qtyButton.setAttribute("data-show", false);
      }

      // Handles removing a selected option, decrements quantity, updates UI and prices
      this.productQuantity--;
      this.updateProgressBar(this.productQuantity);
      this.options[index].removeAttribute("data-picked"); // Remove "picked" status

      if (this.productQuantity > 3) {
        this.options[index].setAttribute("data-additional", ""); // Mark option as additional
      }

      this.options[index]
        .querySelectorAll(".tabs-configurator__option-product")
        .forEach((item) => item.remove());

      this.removePickedProductCard(index); // Remove corresponding product card
      this.updateActionButtonState(); // Adjust ACT button based on updated quantity
      this.checkNextAvailableOption(); // Find the next available option
      this.updatePrices();
      this.updateDiscountMessage();
    }

    resortOptions() {
      const activeOptions = Array.from(this.options).filter((option) =>
        option.hasAttribute("data-picked"),
      );

      const imgSrc = [];
      activeOptions.forEach((option) => {
        this.options[parseInt(option.dataset.index)].removeAttribute(
          "data-picked",
        ); // Remove "picked" status

        const optionImage = option.querySelector(
          ".tabs-configurator__option-product",
        );
        imgSrc.push(optionImage.src);

        this.options[parseInt(option.dataset.index)]
          .querySelectorAll(".tabs-configurator__option-product")
          .forEach((item) => item.remove());
      });

      activeOptions.forEach((option, index) => {
        const img = this.createImageElement(imgSrc[index]); // Create and append product image
        this.options[index].setAttribute("data-picked", "");
        this.options[index].append(img);
        this.options[index].dataset.id = option.dataset.id; // Store button id
        this.options[index].dataset.index = index; // Store option index
        this.options[index].removeAttribute("data-additional"); // Remove additional marker
        this.options[index].dataset.sale = option.dataset.sale; // Store sale price
      });
    }

    createImageElement(src) {
      // Creates an image element with a provided source
      const img = document.createElement("img");
      img.classList.add("tabs-configurator__option-product");
      img.src = src;
      return img;
    }

    pickOption(img, btn) {
      if (this.optionIndex == this.options.length - 1) {
        this.addNewOption();
      }
      console.log(this.optionIndex, this.options.length);
      // Marks the current option as picked and appends the image to it
      this.options[this.optionIndex].setAttribute("data-picked", "");
      this.options[this.optionIndex].append(img);
      this.options[this.optionIndex].dataset.id = btn.dataset.id; // Store button id
      this.options[this.optionIndex].dataset.index = this.optionIndex; // Store option index
      this.options[this.optionIndex].removeAttribute("data-additional"); // Remove additional marker
      this.options[this.optionIndex].dataset.sale = btn.dataset.sale; // Store sale price
    }

    updatePrices() {
      // Add new prices from the selected option
      const compareAtPrice = this.calculatePrice();

      const currentActiveOptions = Array.from(
        this.getCurrentOptionList(),
      )?.filter((option) => option.hasAttribute("data-picked")).length;

      const bundleBuilderDiscount = JSON.parse(
        this.dataset.bundleBuilderDiscount,
      );

      let discount = 0;

      for (const discountLevel of bundleBuilderDiscount) {
        if (
          currentActiveOptions >= discountLevel.totalQuantityMin &&
          discountLevel.discountPercentage > discount
        ) {
          discount = discountLevel.discountPercentage * 0.01;
        }
      }

      console.log("USING DISCOUNT", discount);

      const salePrice = compareAtPrice * (1 - discount);

      // Update the displayed price values
      this.salePrice.textContent = this.formatMoney(salePrice || 0);
      this.originalPrice.textContent = this.formatMoney(compareAtPrice || 0);

      const priceDiff = compareAtPrice - salePrice;
      this.progressBar.querySelectorAll(".tabs-configurator__progress-level-text").forEach((textElement) => {
        textElement.textContent = "Du sparst " + this.formatMoney(priceDiff);
      });

      if (compareAtPrice == 0 || salePrice == compareAtPrice) {
        this.originalPrice.textContent = "";
      }
    }

    parsePrice(priceString) {
      // Parses a price string (e.g., "999 €") into an integer (cents)
      let cleanedPrice = priceString.replace("€", "").replace(",", ".");
      return Math.round(parseFloat(cleanedPrice) * 100);
    }

    formatMoney(price) {
      // Formats integer price (in cents) back into a price string with Euro symbol
      return (price / 100).toFixed(2).replace(".", ",") + " €";
    }

    calculatePrice() {
      let salePrice = 0;

      this.getCurrentOptionList().forEach((option) => {
        if (
          option.hasAttribute("data-picked") &&
          option.hasAttribute("data-sale") &&
          option.dataset.sale
        ) {
          salePrice += parseInt(option.dataset.sale);
        }
      });

      return salePrice;
    }

    removePickedProductCard(index) {
      // Removes the product card corresponding to the removed option
      const selectedId = this.options[index].dataset.id;
      this.cardButtons.forEach((btn) => {
        if (btn.dataset.id === selectedId) {
          btn.removeAttribute("data-active"); // Remove picked status from the button
        }
      });
    }

    updateDiscountMessage() {
      if (this.productQuantity < 2) {
        this.discounts[0].setAttribute("data-active", ""); // Activate no discount message
        this.discounts[1].removeAttribute("data-active"); // Deactivate other discounts
        this.discounts[0].innerHTML = this.discountFistText.replace(
          "%p",
          3 - this.productQuantity,
        );
        return;
      }
      const bundleBuilderDiscount = JSON.parse(
        this.dataset.bundleBuilderDiscount,
      );
      let discountLevel = 0;

      for (const level of bundleBuilderDiscount) {
        if (
          level.discountPercentage > discountLevel &&
          this.productQuantity >= level.totalQuantityMin
        ) {
          discountLevel = level.discountPercentage;
        }
      }

      this.discounts[1].setAttribute("data-active", "");
      this.discounts[0].removeAttribute("data-active");
      this.discounts[1].innerHTML = this.discountSecondText.replace(
        "%d",
        discountLevel.toString() + "%",
      );
    }

    updateOptionData(btn) {
      // Stores the selected option's price details in the dataset
      this.options[this.optionIndex].dataset.sale = btn.dataset.sale;
      this.options[this.optionIndex].dataset.original = btn.dataset.original;
    }

    resetOptionPrices(index) {
      // Resets the sale and original price values for the removed option
      this.options[index].dataset.sale = "0000";
      this.options[index].dataset.original = "0000";
    }

    calculateTotalPrices() {
      // Calculates the total sale and original prices by summing all picked options
      let salePrice = 0;
      let originalPrice = 0;
      this.options.forEach((option) => {
        salePrice += parseInt(option.dataset.sale);
        originalPrice += parseInt(option.dataset.original);
      });
      return { salePrice, originalPrice };
    }

    updateActionButtonState() {
      if (this.productQuantity == 4) {
        this.actButton.setAttribute("data-state", "atc");
        this.actButton.removeAttribute("disabled");
        return;
      }

      if (this.barIndex == this.bars.length - 1 || this.bars.length == 0) {
        if (this.productQuantity > 0) {
          this.actButton.setAttribute("data-state", "atc");
          this.actButton.removeAttribute("disabled");
        } else {
          this.actButton.setAttribute("data-state", "atc");
          this.actButton.setAttribute("disabled", true);
        }
      } else {
        this.actButton.removeAttribute("disabled");
        this.actButton.setAttribute("data-state", "continue");
      }
    }

    checkNextAvailableOption() {
      // Finds the next option that hasn't been picked
      this.optionIndex = Array.from(this.options).filter((option) =>
        option.hasAttribute("data-picked"),
      ).length;

      // If no unpicked option is found, adds a new one and rechecks
      if (this.optionIndex === -1) {
        this.addNewOption();
        this.options = this.getCurrentOptionList(); // Refresh options list
        this.optionIndex = [...this.options].findIndex(
          (option) => !option.hasAttribute("data-picked"),
        );
      }
    }

    addNewOption() {
      // Clones the first option and marks it as an additional option
      const newOption = this.cloneOption.cloneNode(true);
      newOption.setAttribute("data-additional", "");
      this.picker.append(newOption);
      this.options = this.querySelectorAll(".tabs-configurator__option");
    }

    getCurrentOptionList() {
      // Returns the current list of option elements
      return this.querySelectorAll(".tabs-configurator__option");
    }

    // ============ TABS SETTINGS ============

    // Initialize tabs and set up event listeners
    initializeTabs() {
      // Add click event listener to each bar to handle tab switching
      this.bars.forEach((bar) => {
        const index = parseInt(bar.dataset.index);
        bar.addEventListener("click", () => {
          this.handleTabSelection(index, bar); // Handle tab selection logic
          this.tabIndex = index; // Update the current tab index
        });
      });

      // Set up navigation to the next tab on ACT button click
      this.setupActButtonNavigation();
    }

    // Handle tab selection, activate the selected tab and update scroll position
    handleTabSelection(index, bar) {
      this.activateSelectedTab(index, bar); // Activate the tab and its corresponding bar
      this.updateScrollPosition(index); // Scroll the navigation to the active tab
      this.barIndex = index; // Update the current bar index
      this.updateActionButtonState();
    }

    // Set up navigation to the next tab on ACT button click
    setupActButtonNavigation() {
      this.actButton.addEventListener("click", () => {
        // Proceed only if the ACT button is not active
        if (this.actButton.dataset.state === "continue") {
          // Increment bar index, looping back to the first tab if at the last tab
          this.barIndex = (this.barIndex + 1) % this.bars.length;

          // Activate the next tab and update the scroll position
          this.activateSelectedTab(this.barIndex, this.bars[this.barIndex]);
          this.updateScrollPosition(this.barIndex);
          setTimeout(() => {
            this.updateActionButtonState();
          }, 100);
        }
      });
    }

    // Activate the tab and bar at the given index
    activateSelectedTab(index, bar) {
      this.resetActiveStates(); // Clear any active states
      this.setActiveStates(this.tabs[index], bar, this.tilesList[index]); // Set the new active tab, bar, and tiles list
    }

    // Reset all active states from tabs and bars
    resetActiveStates() {
      this.clearActiveAttributes(this.tabs); // Remove active state from all tabs
      this.clearActiveAttributes(this.bars); // Remove active state from all bars
      this.clearActiveAttributes(this.tilesList); // Remove active state from all tiles list
    }

    // Remove the 'data-active' attribute from all elements in a given list
    clearActiveAttributes(elements) {
      elements.forEach((element) => element.removeAttribute("data-active"));
    }

    // Set the 'data-active' attribute on the selected tab and bar
    setActiveStates(tab, bar, tilesList) {
      console.log(tab, bar, tilesList);
      tab.setAttribute("data-active", ""); // Mark the selected tab as active
      bar.setAttribute("data-active", ""); // Mark the corresponding bar as active
      tilesList.setAttribute("data-active", ""); // Mark the corresponding tiles list as active
    }

    // Update the scroll position of the navigation to keep the active tab in view
    updateScrollPosition(index) {
      const scrollOffset = this.calculateScrollOffset(index); // Calculate new scroll offset
      this.navigation.scrollLeft = scrollOffset; // Scroll to the new position
    }

    // Calculate the scroll position based on the index and bar width
    calculateScrollOffset(index) {
      const barWidth = this.bars[0].clientWidth; // Get the width of a single bar
      // Adjust scroll offset based on whether the new index is ahead or behind
      return this.barIndex > index ? barWidth * (index - 1) : barWidth * index;
    }

    // ============ FILTERS SETTINGS ============

    // Initialize filters and attach click event listeners to each tile
    initializeFilters() {
      this.tiles.forEach((tile) => {
        tile.addEventListener("click", () => {
          const activeInputLength = Array.from(this.inputs).filter(input => input.checked).length;
          console.log("Activelength", activeInputLength)
          if(activeInputLength == 0) {
            this.cards.forEach((card) => {
              card.dataset.active = true;
            });
            return;
          }
          // Reset all cards to inactive
          this.resetActiveCards();

          // Apply active state to matching cards based on selected inputs
          setTimeout(() => this.applyActiveCards(), 0); // Slight delay to ensure input states are updated
        });
      });
    }

    // Deactivates cards that are currently active
    resetActiveCards() {
      this.cards.forEach((card) => {
        if (card.parentElement.hasAttribute("data-active")) {
          // Check if parent has 'data-active'
          card.dataset.active = false; // Deactivate the card
        }
      });
    }

    // Checks inputs and activates matching cards based on input values
    applyActiveCards() {
      const checkedInputs = Array.from(this.inputs).filter((input) => input.checked);

      if (checkedInputs.length === 0) {
        // No filters selected — show all cards in the active tab
        this.cards.forEach((card) => {
          if (card.parentElement.hasAttribute("data-active")) {
            card.setAttribute("data-active", true);
          }
        });
        return;
      }

      checkedInputs.forEach((input) => {
        this.cards.forEach((card) => {
          if (input.value === card.dataset.value) {
            card.setAttribute("data-active", true);
          }
        });
      });
    }

    // ============ Ajax API ============

    // Add selected products to the cart and update cart drawer
    async addProductsToCartDrawer() {
      // Set up click event listener for the action button
      this.actButton.addEventListener("click", async () => {
        // Only proceed if the action button is active
        if (
          this.actButton.dataset.state === "atc" &&
          this.actButton.disabled == false
        ) {
          const uuid = () => {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
              /[xy]/g,
              function (c) {
                const r = (Math.random() * 16) | 0,
                  v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
              },
            );
          };
          const bundleId = uuid();
          const items = Array.from(this.options)
            .filter(
              (option) =>
                option.dataset.id && option.hasAttribute("data-picked"),
            ) // Filter options that have a product ID
            .map((option) => ({
              id: option.dataset.id, // Get product ID from dataset
              quantity: 1, // Set quantity to 1 for each product
              properties: {
                _custom_bundle: bundleId,
                _myshopify: Shopify.shop,
              },
            }));

          // Send the add-to-cart request with selected items
          await this.sendAddToCartRequest(items);
        }
      });
    }

    // Send an AJAX request to add products to the Shopify cart
    async sendAddToCartRequest(items) {
      // Ask Shopify to render the drawer + header count in the same response
      const formData = {
        items,
        sections: ["cart-drawer", "cart-bubble"],
        sections_url: window.location.pathname,
      };

      try {
        // Make a POST request to the Shopify cart API
        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" }, // Set content type to JSON
            body: JSON.stringify(formData), // Send the items as JSON
          },
        );

        const data = await response.json().catch(() => ({}));

        // Shopify returns 422 with a description when e.g. an item is sold out
        if (!response.ok) {
          this.showError(data.description || data.message);
          return;
        }

        this.showError(false);
        this.updateCartDrawer(data.sections || {});
      } catch (error) {
        console.error("Error:", error);
        this.showError();
      }
    }

    // Show (or hide, with false) the error message above the add-to-cart button
    showError(message) {
      const wrapper = this.querySelector(".tabs-configurator__error");
      if (!wrapper) return;
      if (message === false) {
        wrapper.hidden = true;
        return;
      }
      wrapper.querySelector(".tabs-configurator__error-message").textContent =
        message || wrapper.dataset.fallback;
      wrapper.hidden = false;
    }

    // Update the cart drawer and header cart count from the rendered sections
    updateCartDrawer(sections) {
      const parse = (html) =>
        new DOMParser().parseFromString(html || "", "text/html");

      // Header cart count
      const currentCount = document.querySelector(
        "#cart-drawer-toggle .thb-item-count",
      );
      const newCount = parse(sections["cart-bubble"]).querySelector(
        ".thb-item-count",
      );
      if (currentCount && newCount) {
        currentCount.innerHTML = newCount.innerHTML;
      }

      // Scope to the cart drawer: other side panels (e.g. the search drawer) also use .side-panel-inner
      const cartDrawer = document.getElementById("Cart-Drawer");
      const currentContent = cartDrawer?.querySelector(".side-panel-inner");
      const newContent = parse(sections["cart-drawer"]).querySelector(
        ".cart-drawer .side-panel-inner",
      );
      if (!currentContent || !newContent) {
        // Bundle is already in the cart; show it on the cart page instead
        window.location.href = `${window.Shopify.routes.root}cart`;
        return;
      }

      currentContent.innerHTML = newContent.innerHTML;

      // Re-bind remove buttons, notes and terms in the new drawer content
      if (typeof CartDrawer !== "undefined") {
        new CartDrawer();
      }

      cartDrawer.classList.add("active");
      document.body.classList.add("open-cc");
      if (typeof dispatchCustomEvent === "function") {
        dispatchCustomEvent("cart-drawer:open");
      }
    }
  }

  customElements.define("tabs-configurator", TabsConfigurator);
}

if (!customElements.get("configurator-option")) {
  class ConfiguratorOption extends HTMLElement {
    constructor() {
      super();
      this.tabsConfigurator = document.querySelector("tabs-configurator");
      this.remove = this.querySelector(".tabs-configurator__option-remove");
      this.remove.addEventListener("click", () => {
        this.tabsConfigurator.handleOptionRemove(parseInt(this.dataset.index));
        this.tabsConfigurator.resortOptions();
      });
    }
  }
  customElements.define("configurator-option", ConfiguratorOption);
}
